export const DATE_FORMAT1="YYYY-MM-DD"
export const DATE_FORMAT2="DD MMM, YYYY"
export const DATE_FORMAT3="MMM YYYY"
export const DATE_FORMAT4="MMM-YYYY"
export const DATE_FORMAT5="DD, MMM yy"
export const DATE_FORMAT6="MMMM, DD YYYY"
export const DATE_FORMAT7="MMM DD, YYYY"

export const TIME_FORMAT1="hh:mm a"




export const PROFILE_COMPLETION_FOCUS_TABS={
    TARGET:'TARGET',
    JOB_DETAILS:"JOB_DETAILS",
    JOB_RELATED_INFO:'JOB_RELATED_INFO'
}


export const JOB_APPLICATION_STATUS={
    AWAITING:"Awaiting",
   REVIEWED:'Reviewed',
  SHORTLIST_CANDIDATE:'Shortlist Candidate',
   HIRED:'Hired',
   ON_HOLD:'On Hold',
    NOT_GOOD_FIT:'Not a Good Fit',
}

export const COLOR_CONSTANTS={
    shimmer_listing:"#eeeded"
}

// export const BASE_URL="https://dev-stag.01hire.com"
export const BASE_URL="https://prod-api.01hire.com/"



export const SELECTED_NAV_OPTION = {
    JOBS: "JOBS",
    CHATS: "CHATS",
    INTERVIEWS: "INTERVIEWS",
    TEST_CENTER: "TEST_CENTER",
    PROFILE:'PROFILE'
  };